export default __webpack_public_path__ + "static/media/data.123f98c5.jpeg";